const NS = 'MyAccountQuizCentrePage';
const CLS = 'myAccountQuizCentrePage';

import Handlebars from 'handlebars';
import { ProgressRadialCheckWidget } from '../../../widgets/progressRadialCheckWidget/js/progressRadialCheckWidget';
import { ifCond } from '../../../../../handlebarsHelpers';

export class MyAccountQuizCentrePage {
	constructor(element) {
		this.element = element;
		this.$element = $(element);
		this.searchResultsApi = this.$element.data('quizCenterApi');

		this.$element.find(`.${CLS}-filter`).val('').change();

		this.loadTemplates();

		this.params = {};
		this.loadResults(this.params);

		this.$resultsContainer = this.$element.find(`.${CLS}-resultsContainer`);
		this.emptyMessage = this.$element.data('emptyMessage');

		this.$searchResultsFilter = $(`.${CLS}-filter`);
		this.$element.on('change', `.${CLS}-filter`, (event) => {
			let $element = $(event.currentTarget);
			let filterKey = $element.data('filter-key');

			// The [data-filter-key="programs"] select was changed
			// Change the values of the courseSelect
			if(filterKey === 'programs') {
				let courseSelectApi = $element.data('courseSelectApi');
				let $courseSelect = this.$searchResultsFilter.filter('[data-filter-key="course"]');

				$courseSelect.empty();
				$courseSelect.selectpicker('render');
				$courseSelect.selectpicker('val', '');

				let url = courseSelectApi;
				let params = {
					programId: $element.val()
				};

				if(!_.isEmpty(params)) {
					url += `?${$.param(params)}`;
				}

				$.ajax({
					type: 'GET',
					url: url,
					dataType: 'json',
					success: (response) => {
						let courses = response;
						if(courses && courses.length > 0) {
							$courseSelect.empty();
							$courseSelect.append(() => {
								let markup = '';
								courses.forEach((country) => {
									markup += `<option value="${country.value}">${country.name}</option>`;
								});
								return markup;
							});

							setTimeout(() => {
								$courseSelect.selectpicker('refresh');
								$courseSelect.selectpicker('render');
							}, 100);
						}
					}
				});
			}

			if(!(_.isNil(this.params[filterKey]) && $element.val() === '')) {
				// Ensure that the filterKey does not match the current select value
				if(this.params[filterKey] !== $element.val()) {
					if(_.isNil($element.val()) || $element.val() === '') {
						delete this.params[filterKey];
					}
					else {
						this.params[filterKey] = $element.val();
					}

					this.loadResults(this.params);
				}
			}
		});
	}

	loadResults(params) {
		let url = this.searchResultsApi;

		if(!_.isEmpty(params)) {
			url += `?${$.param(params)}`;
		}

		$.ajax({
			type: 'GET',
			url: url,
			dataType: 'json',
			success: (response) => {
				let results = response;
				if(results && results.length > 0) {
					this.$resultsContainer.html(this.getResultsMarkup(results));
					this.$resultsContainer.find(`[data-wg="ProgressRadialCheckWidget"]`).each((_index, element) => {
						if(element) {
							new ProgressRadialCheckWidget(element);
						}
					});
				}
				else {
					this.$resultsContainer.html(this.getResultsEmptyMarkup());
				}
			}
		});
	}

	getResultsMarkup(results) {
		let resultsMarkup = '';

		results.forEach((item) => {
			_.extend(item, {
				progressRadialCheckWidget: {
					wg: 'progressRadialCheckWidget',
					ns: 'ProgressRadialCheckWidget'
				}
			});

			resultsMarkup += `${this.resourcesBlockRenderer(item)}`;
		});
		return resultsMarkup;
	}

	getResultsEmptyMarkup() {
		return `<div class="results">
			<p>${this.emptyMessage}</p>
		</div>`;
	}

	loadTemplates() {
		let quizItemWidget = require('../../../widgets/quizItemWidget/tmpl/quizItemWidget.hbs');
		Handlebars.registerPartial('quizItemWidget', quizItemWidget);

		let progressRadialCheckWidget = require('../../../widgets/progressRadialCheckWidget/tmpl/progressRadialCheckWidget.hbs');
		Handlebars.registerPartial('progressRadialCheckWidget', progressRadialCheckWidget);

		let template = `
			{{> quizItemWidget
				wg="quizItemWidget"
				ns="QuizItemWidget"
			}}
		`;
		let precompiled = new Function('return ' + Handlebars.precompile(template))();
		this.resourcesBlockRenderer = Handlebars.template(precompiled);

		Handlebars.registerHelper('ifCond', ifCond);
	}
}
